import BasePagination from '@components/common/atoms/BasePagination';
import OrderListViewStore from '@components/order/stores/OrderListViewStore';
import { Box } from '@mui/material';
import _ from 'lodash';
import { observer } from 'mobx-react-lite';
import React from 'react';
import OrderListItem from './OrderListItem';
import OrderDetailsDrawer from './details/OrderDetailsDrawer';

interface OrderListProps {
    orderListViewStore: OrderListViewStore;
    isAdministration?: boolean;
}

const OrderList: React.FC<OrderListProps> = observer(({ orderListViewStore, isAdministration = false }) => {
    const { orders, pagingInfo, onPageChange, onOrderClick } = orderListViewStore;
    return (
        <>
            <Box display={"flex"} flexDirection={"column"} gap={2}>
                {_.map(orders, (order) => (
                    <OrderListItem key={order.id} order={order} onClick={onOrderClick} isAdministration={isAdministration}/>
                ))}
                <BasePagination pagingInfo={pagingInfo} onPageChange={onPageChange} />
            </Box>

            <OrderDetailsDrawer orderListViewStore={orderListViewStore} />
        </>
    )
})

export default OrderList;